import { render, staticRenderFns } from "./StaffStatistics.vue?vue&type=template&id=7cdb0d52&scoped=true&"
import script from "./StaffStatistics.vue?vue&type=script&lang=js&"
export * from "./StaffStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdb0d52",
  null
  
)

export default component.exports